import { Step, StepLabel, Stepper } from "@mui/material";

import {
  GENERATIONS_STEPS,
  generationsProgressStepIndex,
  type GenerationsStepId,
} from "@/features/Generations/steps";

export type GenerationsStepperProps = {
  currentStepId: GenerationsStepId;
};

export function GenerationsStepper({ currentStepId }: GenerationsStepperProps) {
  return (
    <Stepper
      activeStep={generationsProgressStepIndex(currentStepId)}
      sx={{ px: 6, py: 4, overflowX: "auto" }}
    >
      {GENERATIONS_STEPS.map((step) => (
        <Step key={step.id}>
          <StepLabel>{step.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
